module.exports = ":host .form-group {\n  display: flex;\n  align-items: center;\n}\n:host .form-group > div {\n  margin-right: 10px;\n}\n:host .form-group textarea {\n  max-width: 450px;\n  margin-top: 10px;\n}\n:host p {\n  margin-bottom: 15px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ops-support/covid-19/reopening/covid-19-reopening.component.less
// module id = 1038
// module chunks = 0